module.exports = __webpack_public_path__ + "static/media/app3.adc8e781.png";